import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';

const ArrowLeft = ({
  size, color, theme, iconTitle,
}) => {
  const iconColor = color || (theme && theme.iconColor);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29.04492 27.43504"
      width={size}
      height={size}
    >
      <title>{iconTitle}</title>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            fill={iconColor}
            d="M.05664,13.997.0542,13.98539a.70048.70048,0,0,1-.02686-.12787.714.714,0,0,1-.02612-.13446L0,13.71726l.00122-.0058A.714.714,0,0,1,.02734,13.577a.70048.70048,0,0,1,.02686-.12787l.00244-.01166.006-.00885a.711.711,0,0,1,.10022-.14868.66626.66626,0,0,1,.04028-.06268l.00647-.00671.00134-.00134L12.8125.21726a.71754.71754,0,0,1,1.0293,1L2.41357,12.99949H28.32715a.71777.71777,0,1,1,0,1.43555H2.41357L13.8418,26.21726a.71754.71754,0,1,1-1.0293,1L.21094,14.22532.20959,14.224l-.00647-.00671a.66626.66626,0,0,1-.04028-.06268.711.711,0,0,1-.10022-.14868Z"
          />
        </g>
      </g>
    </svg>
  );
};

ArrowLeft.propTypes = {
  color: PropTypes.string,
  iconTitle: PropTypes.string,
  size: PropTypes.number,
  theme: PropTypes.object,
};

ArrowLeft.defaultProps = {
  color: null,
  iconTitle: null,
  size: 26,
  theme: null,
};

export default withTheme(ArrowLeft);
